export default  {
    component: 'calculated_analytics_component',
    name: 'annunciator_param',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Component',
            param: 'component',
            type: 'text',
            description: `Options are mentioned below:
            - AC Energy
            - AC Yield
            - CUF
            - DGR Report - 1
            - DGR Report - 2
            - Insolation / Ref. Yield
            - PR vs Actual Energy vs Rated Energy
            - Array Capture Loss
            - BOS Efficiency
            - BOS Loss
            - DC Energy
            - DC Yield
            - Mean Actual Array Efficiency
            - PR
            - Rated Array DC efficiency
            - Rated Energy
            - System AC Efficiency
            - Temp. Corrected PR`
          },
          {
            name: 'Component Alias',
            param: 'component_alias',
            type: 'text',
            description: `Corresponding to Component below mentioned component alias should be added:
            - AC Energy - **ac_energy**
            - AC Yield - **ac_yield**
            - CUF - **cuf**
            - DGR Report - 1 - **dgr**
            - DGR Report - 2 - **dgr2**
            - Insolation / Ref. Yield - **insolation**
            - PR vs Actual Energy vs Rated Energy - **pr**
            - Array Capture Loss - **array_capture_loss**
            - BOS Efficiency - **bos_efficiency**
            - BOS Loss - **bos_loss**
            - DC Energy - **dc_energy**
            - DC Yield - **dc_yield**
            - Mean Actual Array Efficiency - **mean_actual_array_efficiency**
            - PR - **performance_ratio**
            - Rated Array DC efficiency - **array_dc_efficiency**
            - Rated Energy - **rated_energy**
            - System AC Efficiency - **system_ac_efficiency**
            - Temp. Corrected PR - **temp_pr**`
          }
    ]
  }
